import * as React from 'react';
import { Button, Responsive, RoundButton } from '@cian/ui-kit';
import { IconActionClose16, IconActionClose24 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';
import clsx from 'clsx';

export interface ICloseButtonProps {
  onClose(): void;
}

export function CloseButton({ onClose }: ICloseButtonProps): React.JSX.Element {
  return (
    <>
      <Responsive desktop>
        <div className={clsx(styles['container-desktop'], styles['container'])}>
          <RoundButton
            aria-label="Закрыть"
            data-testid="newbuildings-map-close"
            type="button"
            icon={<IconActionClose16 color="icon-inverted-default" />}
            title="close-desktop"
            theme="dark"
            onClick={onClose}
          ></RoundButton>
        </div>
      </Responsive>
      <Responsive phone tablet>
        <div className={clsx(styles['container-mobile'], styles['container'])}>
          <Button
            size="M"
            aria-label="Закрыть"
            theme="inverted"
            data-testid="newbuildings-map-close"
            beforeIcon={<IconActionClose24 color="icon-primary-default" />}
            type="button"
            onClick={onClose}
          ></Button>
        </div>
      </Responsive>
    </>
  );
}
